import {
  titleUI,
  textareaUI,
  textareaSchema,
} from 'platform/forms-system/src/js/web-component-patterns';

export default {
  uiSchema: {
    ...titleUI('Additional remarks'),
    remarks: textareaUI({
      title: 'Additional remarks',
      hint: 'Optional. Use this space for any comments or information relevant to your claim that isn’t covered elsewhere in this form.',
    }),
  },
  schema: {
    type: 'object',
    properties: {
      remarks: textareaSchema,
    },
  },
};
